// src/components/Home.js
import React from 'react';
import AccountSetting from "../components/AccountSetting/AccountSetting";

const AccountSettingPage = () => {
	return (
		<AccountSetting />
	);
}

export default AccountSettingPage;